import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home'; 
import Login from './components/Login';
import FishDetails from './components/FishDetails'; 
import Quiz from './components/Quiz'; 
import ForumList from './components/forum/ForumList'; 
import OceanConservationPrograms from './components/OceanConservationPrograms';
import Chatbot from './components/Chatbot';
import ReportProblem from './components/ReportProblem';
import EmergencyResources from './components/EmergencyResources';
import Dashboard from './components/Dashboard';

function App() {

  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/fish-details" element={<FishDetails />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/forum" element={<ForumList />} />
          <Route path="/programs" element={<OceanConservationPrograms />} />
          <Route path="/report" element={<ReportProblem />} />
          <Route path="/emergency" element={<EmergencyResources />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </main>
      <Chatbot />
    </>
  );
}

export default App;
